/**
 * Shopify Standard Storefront Events + Trekkie (first-party boutique).
 * Réf. : https://shopify.dev/docs/storefronts/themes/best-practices/standard-events
 */
(function () {
  'use strict';

  /* Empêche theme.js de dispatcher consentCustomer avant acceptation cookies. */
  (function patchLoadFeaturesConsentGate() {
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
    if (Shopify.loadFeatures.__seoConsentGate) return;
    var original = Shopify.loadFeatures;
    Shopify.loadFeatures = function (features, callback) {
      var consentApiOnly =
        features &&
        features.length === 1 &&
        features[0] &&
        features[0].name === 'consent-tracking-api';
      if (consentApiOnly && typeof callback === 'function') {
        return original.call(this, features, function (error) {
          if (error) return callback(error);
          try {
            var cp = Shopify.customerPrivacy;
            if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) {
              document.dispatchEvent(new CustomEvent('consentCustomer'));
            }
          } catch (e) {}
        });
      }
      return original.apply(this, arguments);
    };
    Shopify.loadFeatures.__seoConsentGate = true;
  })();

  window.metas = window.metas || {};
  if (window.metas.metafield == null) window.metas.metafield = {};
  window.metas.page = window.metas.page || {};

  function syncMetasPageData() {
    try {
      if (
        window.theme &&
        theme.utils &&
        typeof theme.utils.convert === 'function' &&
        window.metas.metafield != null
      ) {
        window.metas.page.data = theme.utils.convert(
          window.metas.metafield.toString().replace('function ()', 'function()')
        );
      }
    } catch (e) {}
  }

  function restoreBodyPointerEvents() {
    try {
      if (document.body && document.body.style.pointerEvents === 'none') {
        document.body.style.pointerEvents = '';
      }
    } catch (e) {}
  }

  function markThemeLoaded() {
    try {
      localStorage.setItem('shopify_loaded', '1');
    } catch (e) {}
  }

  syncMetasPageData();
  restoreBodyPointerEvents();
  markThemeLoaded();

  document.addEventListener('DOMContentLoaded', function () {
    syncMetasPageData();
    restoreBodyPointerEvents();
    markThemeLoaded();
  });

  var SE_READY = null;

  function waitForStandardEvents() {
    if (SE_READY) return SE_READY;
    SE_READY = new Promise(function (resolve) {
      function check() {
        var SE = window.Shopify && window.Shopify.StandardEvents;
        if (SE && SE.PageViewEvent) {
          resolve(SE);
          return;
        }
        setTimeout(check, 20);
      }
      check();
    });
    return SE_READY;
  }

  function routesRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    var u = (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart';
    if (u.indexOf('/cart') !== -1) return u.replace(/cart\/?$/, '');
    return '/';
  }

  function cartJsUrl() {
    return routesRoot() + 'cart.js';
  }

  function cartChangeJsUrl() {
    var u = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || routesRoot() + 'cart/change';
    if (u.indexOf('.js') === -1) u = u.replace(/\/?$/, '') + '.js';
    return u;
  }

  function isFullCartPayload(body) {
    return body && typeof body === 'object' && Array.isArray(body.items);
  }

  function cartUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart_url) || routesRoot() + 'cart';
  }

  function checkoutUrl() {
    return routesRoot() + 'checkout';
  }

  function fetchConfigJs() {
    return window.theme && window.theme.utils && typeof window.theme.utils.fetchConfig === 'function'
      ? window.theme.utils.fetchConfig('javascript')
      : { headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
  }

  function formatPriceFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '0.00';
    return (n / 100).toFixed(2);
  }

  function canTrackShopifyAnalytics() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return false;
      return cp.analyticsProcessingAllowed();
    } catch (e) {
      return false;
    }
  }

  function canTrackMarketing() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp || typeof cp.marketingAllowed !== 'function') return false;
      return cp.marketingAllowed();
    } catch (e) {
      return false;
    }
  }

  function rgpdCookieAllowed(category) {
    try {
      if (!window.theme || !theme.Cookies) return false;
      var val = theme.Cookies.get(category);
      if (val === 'allow') return true;
      val = theme.Cookies.get('rgpd_' + category);
      return val === 'allow';
    } catch (e) {
      return false;
    }
  }

  function syncShopifyConsentFromRgpd() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp || typeof cp.setTrackingConsent !== 'function') return;

    var payload = {
      analytics: rgpdCookieAllowed('statistics'),
      marketing: rgpdCookieAllowed('marketing'),
      preferences: rgpdCookieAllowed('preferences')
    };

    cp.setTrackingConsent(payload, function () {});

    if (payload.analytics) {
      try {
        document.dispatchEvent(new CustomEvent('consentCustomer'));
      } catch (e) {}
      initPageView();
      initCartPageView();
    }
  }

  function trackTrekkieAddedProduct(lineItem) {
    if (!canTrackShopifyAnalytics()) return;
    try {
      var lib = window.ShopifyAnalytics && window.ShopifyAnalytics.lib;
      if (!lib || typeof lib.track !== 'function' || !lineItem) return;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      var productId = lineItem.product_id;
      lib.track('Added Product', {
        currency: currency,
        variantId: lineItem.variant_id,
        productId: productId,
        productGid: productId ? 'gid://shopify/Product/' + productId : undefined,
        name: lineItem.product_title || lineItem.title,
        price: formatPriceFromCents(lineItem.final_price != null ? lineItem.final_price : lineItem.price),
        quantity: lineItem.quantity || 1,
        sku: lineItem.sku || '',
        brand: lineItem.vendor || '',
        variant: lineItem.variant_title || ''
      });
    } catch (e) {}
  }

  function refreshCartBubbles(ajaxCart) {
    if (!ajaxCart) return;
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      if (ajaxCart.item_count > 0) {
        el.classList.remove('hide');
        el.innerHTML = String(ajaxCart.item_count);
      } else {
        el.classList.add('hide');
        el.innerHTML = '0';
      }
    });
    if (typeof window.seoSyncCartBubbles === 'function') {
      window.seoSyncCartBubbles(ajaxCart.item_count);
    }
  }

  function fetchCartJson() {
    return fetch(cartJsUrl(), fetchConfigJs()).then(function (res) {
      if (!res.ok) throw new Error('Cart fetch failed');
      return res.json();
    });
  }

  function normalizeCartResponse(body) {
    if (isFullCartPayload(body)) return Promise.resolve(body);
    return fetchCartJson();
  }

  function dispatchTarget(formOrEl) {
    if (!formOrEl) return document;
    return (
      formOrEl.closest('product-form') ||
      formOrEl.closest('mini-cart') ||
      formOrEl.closest('.cart-section') ||
      formOrEl.closest('.cart__container') ||
      formOrEl
    );
  }

  function emitCartError(target, message, code) {
    waitForStandardEvents().then(function (SE) {
      try {
        var el = dispatchTarget(target);
        if (!el || !el.dispatchEvent) el = document;
        el.dispatchEvent(
          new SE.CartErrorEvent({
            error: message || 'Cart error',
            code: code || 'INVALID'
          })
        );
      } catch (e) {}
    });
  }

  function createCartLinesUpdate(target, payload) {
    if (!canTrackShopifyAnalytics()) {
      return Promise.resolve({ SE: null, deferred: null, el: dispatchTarget(target) });
    }
    return waitForStandardEvents().then(function (SE) {
      if (!SE.CartLinesUpdateEvent || !SE.CartLinesUpdateEvent.createPromise) {
        return { SE: SE, deferred: null, el: dispatchTarget(target) };
      }
      var deferred = SE.CartLinesUpdateEvent.createPromise();
      var el = dispatchTarget(target);
      el.dispatchEvent(
        new SE.CartLinesUpdateEvent(
          Object.assign({}, payload, {
            promise: deferred.promise
          })
        )
      );
      return { SE: SE, deferred: deferred, el: el };
    });
  }

  function resolveCartLinesUpdate(ctx, ajaxCart) {
    if (!ctx || !ctx.deferred || !ctx.SE) return;
    if (ajaxCart && ctx.SE.CartLinesUpdateEvent.createCartFromAjaxResponse) {
      ctx.deferred.resolve({ cart: ctx.SE.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart) });
    } else {
      ctx.deferred.reject(new Error('Cart unavailable'));
    }
  }

  function followRedirect(options) {
    if (!options || !options.redirect) return;
    if (options.redirect === 'checkout') {
      publishCheckoutStarted();
      setTimeout(function () {
        window.location.href = checkoutUrl();
      }, 300);
      return;
    }
    if (options.redirect === 'cart') {
      window.location.href = cartUrl();
    }
  }

  function bumpCartBubbleFromLineItem(lineItem) {
    if (!lineItem) return;
    var qty = Number(lineItem.quantity) || 1;
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      var n = parseInt(String(el.textContent).replace(/[^\d]/g, ''), 10);
      if (!isFinite(n)) n = 0;
      var next = n + qty;
      if (next > 0) {
        el.classList.remove('hide');
        el.innerHTML = String(next);
      }
    });
    var bubble = document.querySelector('.cart-bubble');
    if (bubble && typeof window.seoSyncCartBubbles === 'function') {
      window.seoSyncCartBubbles(parseInt(bubble.textContent, 10) || qty);
    }
  }

  function handleAddToCartSuccess(form, lineItem, options) {
    options = options || {};
    if (lineItem) lineItem.__seoEnriched = true;
    document.dispatchEvent(new CustomEvent('add_to_cart', { detail: lineItem, bubbles: true }));

    bumpCartBubbleFromLineItem(lineItem);
    trackTrekkieAddedProduct(lineItem);

    try {
      if (document.querySelector('mini-cart') && typeof window.seoFetchMinicartSectionHtml === 'function') {
        window._seoMinicartSectionPending = window.seoFetchMinicartSectionHtml();
      }
    } catch (e) {}

    fetchCartJson()
      .then(function (ajaxCart) {
        refreshCartBubbles(ajaxCart);
        document.dispatchEvent(
          new CustomEvent('updateCart', { detail: { lineItem: lineItem, cart: ajaxCart }, bubbles: true })
        );
      })
      .catch(function () {
        document.dispatchEvent(
          new CustomEvent('updateCart', { detail: { lineItem: lineItem }, bubbles: true })
        );
      });

    var payload = {
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: Number(lineItem.variant_id), quantity: Number(lineItem.quantity || 1) }]
    };

    var analyticsChain = createCartLinesUpdate(form, payload).then(function (ctx) {
      return fetchCartJson()
        .then(function (ajaxCart) {
          refreshCartBubbles(ajaxCart);
          resolveCartLinesUpdate(ctx, ajaxCart);
        })
        .catch(function (err) {
          if (ctx && ctx.deferred) ctx.deferred.reject(err);
        });
    });

    if (options.redirect) {
      return analyticsChain.finally(function () {
        followRedirect(options);
      });
    }
    return analyticsChain;
  }

  function enrichAddToCartFromTheme(lineItem) {
    if (!lineItem || lineItem.status || lineItem.__seoEnriched) return;
    lineItem.__seoEnriched = true;
    var form =
      document.querySelector('product-form form.shopify-product-form') ||
      document.querySelector('product-form form');
    trackTrekkieAddedProduct(lineItem);
    try {
      if (document.querySelector('mini-cart') && typeof window.seoFetchMinicartSectionHtml === 'function') {
        window._seoMinicartSectionPending = window.seoFetchMinicartSectionHtml();
      }
    } catch (e) {}
    var payload = {
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: Number(lineItem.variant_id), quantity: Number(lineItem.quantity || 1) }]
    };
    createCartLinesUpdate(form, payload).then(function (ctx) {
      return fetchCartJson()
        .then(function (ajaxCart) {
          refreshCartBubbles(ajaxCart);
          resolveCartLinesUpdate(ctx, ajaxCart);
        })
        .catch(function (err) {
          if (ctx && ctx.deferred) ctx.deferred.reject(err);
        });
    });
  }

  function changeCartLine(opts) {
    opts = opts || {};
    var lineId = opts.lineId;
    var qty = Number(opts.quantity);
    if (lineId == null || !isFinite(qty)) return Promise.reject(new Error('Invalid cart line'));

    var action = qty <= 0 ? 'remove' : 'update';
    var context = opts.context || 'dialog';
    var target = opts.target || document.querySelector('mini-cart') || document.querySelector('.cart-section') || document;
    var linePayload = { id: String(lineId), quantity: qty };

    var silent = !!opts.silent;
    if (!silent && target.classList) target.classList.add('loading');

    var payload = { action: action, context: context, lines: [linePayload] };

    return createCartLinesUpdate(target, payload)
      .then(function (ctx) {
        return fetch(cartChangeJsUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: lineId, quantity: qty })
        })
          .then(function (res) {
            return res.json().then(function (body) {
              if (body && body.status) throw new Error(body.description || body.message || 'Cart change failed');
              return normalizeCartResponse(body);
            });
          })
          .then(function (ajaxCart) {
            resolveCartLinesUpdate(ctx, ajaxCart);
            if (!silent) {
              refreshCartBubbles(ajaxCart);
              document.dispatchEvent(new CustomEvent('updateCart', { bubbles: true }));
            }
            return ajaxCart;
          })
          .catch(function (err) {
            if (ctx && ctx.deferred) ctx.deferred.reject(err);
            emitCartError(target, err && err.message ? err.message : String(err));
            throw err;
          });
      })
      .finally(function () {
        if (!silent && target.classList) target.classList.remove('loading');
      });
  }

  function parseHrefCartChange(href) {
    try {
      var url = new URL(href, window.location.origin);
      return {
        quantity: parseInt(url.searchParams.get('quantity'), 10),
        lineId: url.searchParams.get('id') || url.searchParams.get('line')
      };
    } catch (e) {
      return null;
    }
  }

  function changeCartLineFromHref(href, target, context) {
    var parsed = parseHrefCartChange(href);
    if (!parsed || parsed.lineId == null || !isFinite(parsed.quantity)) {
      return Promise.reject(new Error('Invalid cart URL'));
    }
    return changeCartLine({
      lineId: parsed.lineId,
      quantity: parsed.quantity,
      target: target,
      context: context || 'dialog'
    });
  }

  function swapCartVariant(oldLineId, newVariantId, quantity, target) {
    var remaining = Number(quantity);
    if (!isFinite(remaining) || remaining < 0) remaining = 0;
    return changeCartLine({ lineId: oldLineId, quantity: remaining, target: target, context: 'dialog', silent: true }).then(function () {
      var addUrl =
        (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || routesRoot() + 'cart/add';
      if (addUrl.indexOf('.js') === -1) addUrl = addUrl.replace(/\/?$/, '') + '.js';
      return fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: 'id=' + encodeURIComponent(newVariantId) + '&quantity=1'
      }).then(function (r) {
        return r.json();
      });
    }).then(function (lineItem) {
      if (lineItem && lineItem.status) throw new Error(lineItem.description || 'Add failed');
      return handleAddToCartSuccess(target, lineItem);
    });
  }

  function emitCartView(target, context) {
    if (!canTrackShopifyAnalytics()) return;
    waitForStandardEvents().then(function (SE) {
      if (!SE.CartViewEvent) return;
      fetchCartJson()
        .then(function (ajaxCart) {
          var el = dispatchTarget(target);
          var cartPayload = null;
          if (ajaxCart && SE.CartLinesUpdateEvent && SE.CartLinesUpdateEvent.createCartFromAjaxResponse) {
            cartPayload = SE.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart);
          }
          el.dispatchEvent(
            new SE.CartViewEvent({
              context: context || 'dialog',
              cart: cartPayload
            })
          );
        })
        .catch(function () {
          var el = dispatchTarget(target);
          el.dispatchEvent(new SE.CartViewEvent({ context: context || 'dialog', cart: null }));
        });
    });
  }

  function publishCheckoutStarted() {
    if (!canTrackShopifyAnalytics() && !canTrackMarketing()) return;
    fetchCartJson()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        var sa = window.Shopify && Shopify.analytics;
        if (sa && typeof sa.publish === 'function') {
          sa.publish('checkout_started', {
            cart: {
              currency: cart.currency || 'EUR',
              total_price: (Number(cart.total_price) || 0) / 100,
              line_items: cart.items.map(function (item) {
                return {
                  productId: String(item.product_id),
                  variantId: String(item.variant_id),
                  quantity: item.quantity,
                  price: formatPriceFromCents(item.final_price != null ? item.final_price : item.price),
                  name: item.product_title || item.title,
                  sku: item.sku || ''
                };
              })
            }
          });
        }
        try {
          var lib = window.ShopifyAnalytics && window.ShopifyAnalytics.lib;
          if (lib && typeof lib.track === 'function') {
            lib.track('Started Checkout', {
              currency: cart.currency || 'EUR',
              total: formatPriceFromCents(cart.total_price)
            });
          }
        } catch (e) {}
      })
      .catch(function () {});
  }

  function initCheckoutClickTracking() {
    var checkoutSelector =
      'button[name="checkout"], input[name="checkout"], .checkout__button, a[href*="/checkout"], a[href*="shop.app"]';

    document.addEventListener(
      'click',
      function (ev) {
        var target = ev.target;
        if (!target || !target.closest) return;
        var btn = target.closest(checkoutSelector);
        if (!btn) return;
        publishCheckoutStarted();
      },
      true
    );

    document.addEventListener(
      'submit',
      function (ev) {
        var submitter = ev.submitter;
        if (submitter && submitter.name === 'checkout') {
          publishCheckoutStarted();
        }
      },
      true
    );
  }

  function initCartPageView() {
    var cartRoot =
      document.querySelector('.cart-section') ||
      document.querySelector('.cart__container') ||
      document.querySelector('body.template-cart');
    if (!cartRoot) return;
    emitCartView(cartRoot, 'page');
  }

  function initPageView() {
    if (!canTrackShopifyAnalytics()) return;
    waitForStandardEvents().then(function (SE) {
      try {
        var tpl =
          (window.Shopify && Shopify.theme_settings && Shopify.theme_settings.template) ||
          (document.body && document.body.getAttribute('data-shopify-template')) ||
          '';
        document.dispatchEvent(
          new SE.PageViewEvent({
            page: {
              template: tpl,
              title: document.title,
              url: window.location.href
            }
          })
        );
      } catch (e) {}
    });
  }

  function initMinicartViewTracking() {
    document.querySelectorAll('mini-cart details, details.minicart').forEach(function (details) {
      if (details.dataset.seoCartViewBound === '1') return;
      details.dataset.seoCartViewBound = '1';
      details.addEventListener('toggle', function () {
        if (details.open) emitCartView(details, 'dialog');
      });
    });
  }

  function syncShopifyConsentFromPrivacyBanner(event) {
    if (!event || !event.detail) return;
    try {
      document.dispatchEvent(new CustomEvent('consentCustomer'));
    } catch (e) {}
    if (event.detail.analyticsAllowed) initPageView();
  }

  function notifyConsentCustomerIfAlreadyAllowed() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    if (!cp) return;
    try {
      if (typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) {
        document.dispatchEvent(new CustomEvent('consentCustomer'));
      }
    } catch (e) {}
  }

  function bootstrapConsentApi() {
    if (!window.Shopify || !Shopify.loadFeatures) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
      notifyConsentCustomerIfAlreadyAllowed();
    });
  }

  function initAll() {
    if (canTrackShopifyAnalytics()) {
      initPageView();
      initCartPageView();
    }
    initMinicartViewTracking();
    initCheckoutClickTracking();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event && event.detail && event.detail.analyticsAllowed) {
      initCartPageView();
    }
  });

  document.addEventListener('visitorConsentCollected', syncShopifyConsentFromPrivacyBanner);

  document.addEventListener('shopify:section:load', function () {
    initMinicartViewTracking();
    initCheckoutClickTracking();
  });

  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted) bootstrapConsentApi();
  });

  document.addEventListener('add_to_cart', function (ev) {
    if (!ev || !ev.detail || ev.detail.__seoEnriched) return;
    enrichAddToCartFromTheme(ev.detail);
  });

  window.SeoShopifyTracking = {
    waitForStandardEvents: waitForStandardEvents,
    routesRoot: routesRoot,
    cartJsUrl: cartJsUrl,
    cartChangeJsUrl: cartChangeJsUrl,
    cartUrl: cartUrl,
    checkoutUrl: checkoutUrl,
    fetchCartJson: fetchCartJson,
    refreshCartBubbles: refreshCartBubbles,
    trackTrekkieAddedProduct: trackTrekkieAddedProduct,
    handleAddToCartSuccess: handleAddToCartSuccess,
    enrichAddToCartFromTheme: enrichAddToCartFromTheme,
    emitCartError: emitCartError,
    emitCartView: emitCartView,
    changeCartLine: changeCartLine,
    changeCartLineFromHref: changeCartLineFromHref,
    swapCartVariant: swapCartVariant,
    syncShopifyConsentFromRgpd: syncShopifyConsentFromRgpd,
    publishCheckoutStarted: publishCheckoutStarted,
    canTrackShopifyAnalytics: canTrackShopifyAnalytics
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('DOMContentLoaded', bootstrapConsentApi);
  if (document.readyState !== 'loading') {
    bootstrapConsentApi();
  }
})();
